export enum BanPopupType {
  NotBanned = 0,
  Banned = 1,
  Unbanned = 2,
  RemainBanned = 4
}
